import { getData } from "./index.svc"

export const getReport = async (body) => await getData('report', 'POST', body)